module.exports = __webpack_public_path__ + "static/scale-model-of-garden-grove-california-59ad40cb3447260f449e4031ff4357cd.png";